import axios from "axios"
import { AUTH_TOKEN, REACT_APP_API } from "../constants";
import { apiBadRequest, apiGetSuccess, apiServerError } from "./helpers";

let adUsercontroller = null;
let adUserCountsController = null;
let getAllDomainController = null;
let adDomainController = null;
let addGatewayController = null;
let getGatewaysController = null;
let lockoutEventsController = null;
let updateGatewayModeController = null;
let updateDomainEnforcementController = null;
let groupsByDomainController = null;
let updateEnrolledGroupsController = null;
let getMFAProviderController = null;
let setMFAProviderController = null;
let deleteMFAProviderController = null;
let getAuthLogController = null;
let getUserAuthLogController = null;
let getAuthBadSourcesController = null;
let enrollmentSummaryController = null;
let enrollmentStatusController = null;
let sendEnrollmentEmailController = null;
let consoleInviteEmailController = null;
let adminInviteController = null;
let selfEnrollController = null;
let mfaStatusController = null;
let totpBeginSetupController = null;
let totpConfirmSetupController = null;
let beginAuthRegistrationController = null;
let finishRegistrationController = null;

export const dispatchGetAllAdUsers = async ({ payload, onSuccess, onFailure, onError }) => {
    // Cancel previous request if it still exists
    if (adUsercontroller) {
        adUsercontroller.abort();
    }

    // Create a new AbortController for the new request
    adUsercontroller = new AbortController();

    try {
        const { data, status } = await axios.post(`${REACT_APP_API}/ad/GetAllAdUsers`, payload, {
            signal: adUsercontroller.signal,
            headers: {
                "X-Authorization": AUTH_TOKEN(),
                withCredentials: true,
            },
        })
        if (apiGetSuccess({ status })) {
            return onSuccess(data);
        }
    } catch ({ response, status }) {
        if (apiBadRequest({ status })) return onFailure({ message: "Please Check the API URL" })
        if (apiServerError({ status })) return onError({ message: response?.data?.error });
        if (response?.data?.message === "Invalid credentials" || status === 401) return onFailure({ message: "Credentials are invalid", isLogout: true })
    }
}

export const dispatchGetAdUserCounts = async ({ payload, onSuccess, onFailure, onError }) => {
    if (adUserCountsController) {
        adUserCountsController.abort();
    }
    adUserCountsController = new AbortController();

    try {
        const { data, status } = await axios.post(`${REACT_APP_API}/ad/GetAllAdUsers`, payload, {
            signal: adUserCountsController.signal,
            headers: {
                "X-Authorization": AUTH_TOKEN(),
                withCredentials: true,
            },
        })
        if (apiGetSuccess({ status })) {
            return onSuccess(data);
        }
    } catch ({ response, status }) {
        if (apiBadRequest({ status })) return onFailure({ message: "Please Check the API URL" })
        if (apiServerError({ status })) return onError({ message: response?.data?.error });
        if (response?.data?.message === "Invalid credentials" || status === 401) return onFailure({ message: "Credentials are invalid", isLogout: true })
    }
}


export const dispatchAdDomain = async({ payload, onSuccess, onFailure, onError }) => {
// Cancel previous request if it still exists
    if (adDomainController) {
        adDomainController.abort();
    }
    // Create a new AbortController for the new request
    adDomainController = new AbortController();

    try {
        const { data, status } = await axios.post(`${REACT_APP_API}/ad/AddDomain`, payload, {
            signal: adDomainController.signal,
            headers: {
                "X-Authorization": AUTH_TOKEN(),
                withCredentials: true,
            },
        })
        if (apiGetSuccess({ status })) {
            return onSuccess(data);
        }
    } catch ({ response, status }) {
        if (status === 409) return onFailure({ message: response?.data?.error })
        if (status === 400) return onFailure({ message: response?.data?.message });
        if (apiBadRequest({ status })) return onFailure({ message: "Please Check the API URL" })
        if (apiServerError({ status })) return onError({ message: response?.data?.error });
        if (response?.data?.message === "Invalid credentials" || status === 401) return onFailure({ message: "Credentials are invalid", isLogout: true })
    }
}

export const dispatchGetAllDoamins = async ({ payload, onSuccess, onFailure, onError }) => {
    // Cancel previous request if it still exists
    if (getAllDomainController) {
        getAllDomainController.abort();
    }

    // Create a new AbortController for the new request
    getAllDomainController = new AbortController();

    try {
        const { data, status } = await axios.post(`${REACT_APP_API}/ad/GetAllDomains`, payload, {
            signal: getAllDomainController.signal,
            headers: {
                "X-Authorization": AUTH_TOKEN(),
                withCredentials: true,
            },
        })
        if (apiGetSuccess({ status })) {
            return onSuccess(data);
        }
    } catch ({ response, status }) {
        if (apiBadRequest({ status })) return onFailure({ message: "Please Check the API URL" })
        if (apiServerError({ status })) return onError({ message: response?.data?.error });
        if (response?.data?.message === "Invalid credentials" || status === 401) return onFailure({ message: "Credentials are invalid", isLogout: true })
    }
}

const dispatchPost = async (endpoint, controllerRef, { payload, onSuccess, onFailure, onError }) => {
    if (controllerRef.current) controllerRef.current.abort();
    controllerRef.current = new AbortController();
    try {
        const { data, status } = await axios.post(`${REACT_APP_API}${endpoint}`, payload, {
            signal: controllerRef.current.signal,
            headers: {
                "X-Authorization": AUTH_TOKEN(),
                withCredentials: true,
            },
        })
        if (apiGetSuccess({ status })) return onSuccess(data);
    } catch ({ response, status }) {
        if (status === 409) return onFailure({ message: response?.data?.error || "Conflict" });
        if (status === 400) return onFailure({ message: response?.data?.message || "Bad request" });
        if (apiBadRequest({ status })) return onFailure({ message: "Please Check the API URL" });
        if (apiServerError({ status })) return onError({ message: response?.data?.error });
        if (response?.data?.message === "Invalid credentials" || status === 401) return onFailure({ message: "Credentials are invalid", isLogout: true });
    }
};

export const dispatchAddGateway = (args) =>
    dispatchPost("/ad/AddGateway", { get current() { return addGatewayController; }, set current(v) { addGatewayController = v; } }, args);

export const dispatchGetGatewaysByOrg = (args) =>
    dispatchPost("/ad/GetGatewaysByOrg", { get current() { return getGatewaysController; }, set current(v) { getGatewaysController = v; } }, args);

export const dispatchGetLockoutEvents = (args) =>
    dispatchPost("/ad/GetLockoutEvents", { get current() { return lockoutEventsController; }, set current(v) { lockoutEventsController = v; } }, args);

export const dispatchUpdateGatewayMode = (args) =>
    dispatchPost("/ad/UpdateGatewayMode", { get current() { return updateGatewayModeController; }, set current(v) { updateGatewayModeController = v; } }, args);

// Switches a domain between "monitor" and "enforce". The mode lives server-side,
// not in the sensor's config file — it takes effect on the next authentication,
// with nothing to re-download and no DC service to restart.
// Note the camelCase route: every other /ad/ endpoint here is PascalCase.
export const dispatchUpdateDomainEnforcement = (args) =>
    dispatchPost("/ad/updateDomainEnforcement", { get current() { return updateDomainEnforcementController; }, set current(v) { updateDomainEnforcementController = v; } }, args);

export const dispatchGetAllGroupsByDomain = (args) =>
    dispatchPost("/ad/GetAllGroupsByDomain", { get current() { return groupsByDomainController; }, set current(v) { groupsByDomainController = v; } }, args);

export const dispatchUpdateEnrolledGroups = (args) =>
    dispatchPost("/policy/UpdateEnrolledGroups", { get current() { return updateEnrolledGroupsController; }, set current(v) { updateEnrolledGroupsController = v; } }, args);

export const dispatchGetMFAProvider = (args) =>
    dispatchPost("/ad/GetMFAProvider", { get current() { return getMFAProviderController; }, set current(v) { getMFAProviderController = v; } }, args);

export const dispatchSetMFAProvider = (args) =>
    dispatchPost("/ad/SetMFAProvider", { get current() { return setMFAProviderController; }, set current(v) { setMFAProviderController = v; } }, args);

export const dispatchDeleteMFAProvider = (args) =>
    dispatchPost("/ad/DeleteMFAProvider", { get current() { return deleteMFAProviderController; }, set current(v) { deleteMFAProviderController = v; } }, args);

export const dispatchGetAuthLog = (args) =>
    dispatchPost("/ad/GetAuthLog", { get current() { return getAuthLogController; }, set current(v) { getAuthLogController = v; } }, args);

export const dispatchGetUserAuthLog = (args) =>
    dispatchPost("/ad/GetUserAuthLog", { get current() { return getUserAuthLogController; }, set current(v) { getUserAuthLogController = v; } }, args);

export const dispatchGetAuthBadSources = (args) =>
    dispatchPost("/ad/GetAuthBadSources", { get current() { return getAuthBadSourcesController; }, set current(v) { getAuthBadSourcesController = v; } }, args);

// ── Authenticator enrollment ───────────────────────────────────────────────
// The enrollment endpoints need statuses `dispatchPost` cannot express:
//
//   207  the invite row was written but SMTP failed. axios treats it as success
//        (it is 2xx) while `apiGetSuccess` is `status === 200`, so under
//        `dispatchPost` a 207 fires NO callback at all — it reads as a silent
//        no-op. It must never reach onSuccess: the token exists, the mail does not.
//   403  "administrator role required". `dispatchPost` has no branch for it, so
//        it also falls through silently.
//   404  a real, distinct meaning here ("unknown domain", "no such user in this
//        org") rather than `dispatchPost`'s "Please Check the API URL".
//
// Callbacks: onSuccess · onPartial (207) · onForbidden (403) · onNotFound (404)
// · onFailure (400/401/409) · onError (500). Each falls back to onFailure when
// not supplied. Aborted requests fire nothing, as elsewhere in this file.
const dispatchEnrollment = async (endpoint, controllerRef, {
    payload, onSuccess, onPartial, onForbidden, onNotFound, onFailure, onError,
}) => {
    if (controllerRef.current) controllerRef.current.abort();
    controllerRef.current = new AbortController();
    const fail = (arg) => (onFailure ? onFailure(arg) : undefined);
    try {
        const { data, status } = await axios.post(`${REACT_APP_API}${endpoint}`, payload, {
            signal: controllerRef.current.signal,
            // A REQUEST OPTION, not a header. Everywhere else in this file
            // `withCredentials` sits inside `headers`, which sends a literal
            // `withCredentials: true` header and never enables credential mode —
            // so no cookies cross the origin. (The gateway's
            // Access-Control-Allow-Headers even allow-lists the header name,
            // which is how that has gone unnoticed.)
            //
            // It matters here: /ad/* authenticates off X-Authorization, but
            // /mfa/push/* authenticates off the SESSION — that is why its errors
            // are documented as "401 no session" and why adminInvite takes no
            // orgId. Without real credentials those endpoints 401 regardless of
            // what token is in the header.
            withCredentials: true,
            headers: {
                "X-Authorization": AUTH_TOKEN(),
            },
        })
        // A 2xx whose body is not JSON is not a success. The gateway routes
        // unknown paths to the frontend's SPA catch-all, which answers *200
        // text/html* with index.html — so a wrong path arrives here looking
        // healthy, and axios hands over an HTML string instead of an object.
        // Passing that to onSuccess yields a screen full of `undefined`: a QR
        // modal with "no QR image" and a blank expiry, and nothing pointing at
        // the URL as the cause. Fail loudly on the shape instead.
        if (typeof data !== "object" || data === null) {
            console.error(
                `[enrollment] ${endpoint} returned ${status} with a non-JSON body ` +
                `(${typeof data}). The path is probably not routed on this deployment ` +
                `and fell through to the SPA catch-all.`
            );
            return fail({ message: "The server returned an unexpected response.", status });
        }
        if (status === 207) {
            const arg = { message: data?.message || data?.error, data, status };
            return onPartial ? onPartial(arg) : fail(arg);
        }
        // 202: accepted for background work (enrollment campaigns).
        if (apiGetSuccess({ status }) || status === 202) return onSuccess(data);
        return fail({ message: data?.message || data?.error || "Unexpected response", status });
    } catch (err) {
        if (axios.isCancel(err)) return;
        const { response, status } = err || {};
        const msg = response?.data?.error || response?.data?.message;
        if (status === 401 || response?.data?.message === "Invalid credentials")
            return fail({ message: "Credentials are invalid", isLogout: true, status });
        if (status === 403) {
            const arg = { message: msg || "administrator role required", status };
            return onForbidden ? onForbidden(arg) : fail(arg);
        }
        if (status === 404) {
            const arg = { message: msg || "Not found", status };
            return onNotFound ? onNotFound(arg) : fail(arg);
        }
        if (status === 409) return fail({ message: msg || "Conflict", status });
        if (status === 400) return fail({ message: msg || "Bad request", status });
        if (apiServerError({ status })) return onError
            ? onError({ message: msg, status })
            : fail({ message: msg, status });
        return fail({ message: msg || "Request failed", status });
    }
};

export const dispatchGetEnrollmentSummary = (args) =>
    dispatchEnrollment("/ad/GetEnrollmentSummary", { get current() { return enrollmentSummaryController; }, set current(v) { enrollmentSummaryController = v; } }, args);

export const dispatchGetEnrollmentStatus = (args) =>
    dispatchEnrollment("/ad/GetEnrollmentStatus", { get current() { return enrollmentStatusController; }, set current(v) { enrollmentStatusController = v; } }, args);

export const dispatchSendEnrollmentEmail = (args) =>
    dispatchEnrollment("/ad/SendEnrollmentEmail", { get current() { return sendEnrollmentEmailController; }, set current(v) { sendEnrollmentEmailController = v; } }, args);

// The push service is routed ONLY under /api/v1 on the gateway. The /ad/*
// handlers answer at both the bare base and the prefixed path, which is why
// every other call in this file omits it — but /mfa/push/* at the bare base
// falls through to the frontend's own SPA catch-all (`serve -s`) and comes back
// as index.html with a 200, not a 404. Removing this prefix does not produce an
// error; it produces an empty success.
const MFA_BASE = "/api/v1/mfa";
const MFA_PUSH_BASE = `${MFA_BASE}/push`;

// Emails an enrollment invite to a CONSOLE user (Settings → Users & Access).
// /ad/SendEnrollmentEmail is for directory users only: it looks the id up in
// did.ad_users, so a console user's id is not found there (404) — or, worse,
// matches an unrelated AD user. Body { email, tenantId, orgId }; the backend
// takes the org from the session. 207 = token made, email not sent.
export const dispatchSendConsoleInviteEmail = (args) =>
    dispatchEnrollment(`${MFA_PUSH_BASE}/beginSetup`, { get current() { return consoleInviteEmailController; }, set current(v) { consoleInviteEmailController = v; } }, args);

// Body is `{ email }` and nothing else. The org is resolved from the session —
// accepting an orgId from the body would let any admin mint an enrollment token
// for an account in another tenant. Do not add one.
//
// Every call invalidates the previous invite for that user, so this must only
// ever run from an explicit click, never from a panel's render effect.
export const dispatchAdminInvite = ({ email, ...rest }) =>
    dispatchEnrollment(`${MFA_PUSH_BASE}/adminInvite`, { get current() { return adminInviteController; }, set current(v) { adminInviteController = v; } }, { ...rest, payload: { email } });

// Empty body — the signed-in user enrolls their own device. No orgId, no email,
// no userId; the session is the identity.
export const dispatchSelfEnroll = (args) =>
    dispatchEnrollment(`${MFA_PUSH_BASE}/selfEnroll`, { get current() { return selfEnrollController; }, set current(v) { selfEnrollController = v; } }, { ...args, payload: {} });

// ── MFA factor self-service (Settings -> Multi-factor authentication) ──────
//
// Enrolling a factor for the signed-in user. Routed through
// `dispatchEnrollment` rather than `dispatchPost` for the reason documented on
// MFA_PUSH_BASE above and one more: these endpoints authenticate off the
// SESSION, and `dispatchPost` passes `withCredentials` inside `headers`, where
// it is an inert header rather than a request option — no cookie is sent and
// every call 401s regardless of the X-Authorization token.
//
// `email` is in the request body by the service's design. It must always be
// the signed-in user's own address (USER_EMAIL()): the endpoints are
// session-gated but not session-bound, so an email from a query string or a
// form field would read and enrol against somebody else's account.

// Reads the tenant's factor catalogue joined with this user's enrolments.
// `status` = the tenant offers it, `enrolled` = this user registered it.
export const dispatchGetMfaStatus = (args) =>
    dispatchEnrollment(`${MFA_BASE}/status`, { get current() { return mfaStatusController; }, set current(v) { mfaStatusController = v; } }, args);

// Issues a fresh TOTP secret + QR. Calling it again rotates the secret, so it
// must run once per setup attempt — never on a re-verify after a wrong code,
// which would invalidate the QR the user has already scanned.
export const dispatchTotpBeginSetup = (args) =>
    dispatchEnrollment(`${MFA_BASE}/totp/beginSetup`, { get current() { return totpBeginSetupController; }, set current(v) { totpBeginSetupController = v; } }, args);

// Verifies the first code against the pending secret and commits the
// enrolment (an upsert — an existing TOTP row is replaced, not duplicated).
// Returns `backup_codes`, which are shown once and never returned again.
// A wrong code comes back as `{ message: "invalid totp" }`, which the service
// may report as a 400 or as a 200 with no `success` — callers must treat both
// as "try again", keeping the same secret.
export const dispatchTotpConfirmSetup = (args) =>
    dispatchEnrollment(`${MFA_BASE}/totp/confirmSetup`, { get current() { return totpConfirmSetupController; }, set current(v) { totpConfirmSetupController = v; } }, args);

// WebAuthn registration ceremony. The `publicKey` block comes back base64url
// encoded — see src/utils/webauthn.js before handing it to the browser.
export const dispatchBeginAuthRegistration = (args) =>
    dispatchEnrollment(`${MFA_BASE}/beginAuthRegistration`, { get current() { return beginAuthRegistrationController; }, set current(v) { beginAuthRegistrationController = v; } }, args);

// Credentials accumulate: this adds a passkey to the account, it does not
// replace the existing one.
export const dispatchFinishRegistration = (args) =>
    dispatchEnrollment(`${MFA_BASE}/finishRegistration`, { get current() { return finishRegistrationController; }, set current(v) { finishRegistrationController = v; } }, args);

// Invite state for the public /enroll page: `ok` | `used` | `expired` | `unknown`.
//
// Deliberately not routed through the helpers above. This one is a GET, it runs
// unauthenticated (the recipient has no session — the token in the URL *is* the
// credential), and so it must not send X-Authorization: attaching a stale token
// from some other tenant's session in the same browser is how this call starts
// answering for the wrong org.
//
// `apiBase` comes from the invite payload's `b` field rather than the build's
// REACT_APP_API, because the link is opened wherever the recipient happens to be
// and the issuing deployment is the one that can answer for the token.
export const fetchEnrollmentDetails = async ({ apiBase, token, orgId, onSuccess, onFailure }) => {
    try {
        const { data, status } = await axios.get(`${apiBase || REACT_APP_API}/ad/getEnrollmentDetails`, {
            params: { token, orgId },
        });
        // Same SPA-catch-all trap as above: an unrouted path answers 200 with
        // index.html. Treated as "no verdict" rather than a spent token, so the
        // page stays usable instead of falsely telling the recipient their
        // invite is dead.
        if (typeof data !== "object" || data === null) return onFailure({ reason: null, status });
        if (apiGetSuccess({ status })) return onSuccess(data);
        return onFailure({ reason: "unknown" });
    } catch ({ response }) {
        // A reason in the error body is still an answer about the token.
        const reason = response?.data?.reason;
        return onFailure({ reason: reason || "unknown", status: response?.status });
    }
};
// ── Authenticator administration (Settings › Authenticator) ────────────────
//
// All of these are ADMIN-only and take the org from the SESSION
// (RequireSessionOrg refuses a body naming another org), so none of them sends
// an orgId. They ride `dispatchEnrollment` for the session cookie and for its
// 403 / 404 / non-JSON handling.
//
// Each gets its own controller: `dispatchEnrollment` aborts the previous call
// on the same controller, and the page fires several of these at once.
const adminRef = () => ({ current: null });
const adminDevicesListRef = adminRef();
const adminDevicesRevokeRef = adminRef();
const adminDevicesPendingRef = adminRef();
const adminDevicesApproveRef = adminRef();
const adminActivityRef = adminRef();
const campaignCreateRef = adminRef();
const campaignGetRef = adminRef();
const onboardingGetRef = adminRef();
const onboardingSetRef = adminRef();

// A user's phones, active and signed out: { devices: [{ deviceId, deviceName,
// platform, appVersion, osVersion, enrolledAt, lastUsedAt, pushEnabled,
// active, identities }], count }. Body: { email } or { identity: "ad"|"platform", userId }.
export const dispatchAdminDevicesList = (args) =>
    dispatchEnrollment(`${MFA_BASE}/devices/list`, adminDevicesListRef, args);

// Signs one phone out. Body: { deviceId, reason? }. The phone is told by a
// silent push and by 401 device_revoked on its next call.
export const dispatchAdminDevicesRevoke = (args) =>
    dispatchEnrollment(`${MFA_BASE}/devices/revoke`, adminDevicesRevokeRef, args);

// App sign-ins waiting for an administrator (org setting new_device_check =
// admin): { pending: [{ loginTicket, userId, email, deviceName, platform, requestedAt }] }.
export const dispatchAdminDevicesPending = (args) =>
    dispatchEnrollment(`${MFA_BASE}/devices/pending`, adminDevicesPendingRef, { ...args, payload: {} });

// Body: { loginTicket, approve: true|false }.
export const dispatchAdminDevicesApprove = (args) =>
    dispatchEnrollment(`${MFA_BASE}/devices/approve`, adminDevicesApproveRef, args);

// The org's push MFA history, newest first. Body: { email?, statuses?, before?, limit? };
// page with the previous answer's nextCursor as `before`.
export const dispatchAdminActivityList = (args) =>
    dispatchEnrollment(`${MFA_BASE}/activity/list`, adminActivityRef, args);

// Bulk Authenticator invites. Body: { identity: "ad"|"platform", scope:
// "all"|"groups"|"users", ids?, deadline?, reminderDays? }. Answers 202 with
// { campaignId, targets, skipped, toInvite }; the invites go out in the background.
export const dispatchCreateEnrollmentCampaign = (args) =>
    dispatchEnrollment(`${MFA_BASE}/enrollment/campaign`, campaignCreateRef, args);

// Body: { campaignId } → { status, targets, invited, skipped, failed, deadline, ... }.
export const dispatchGetEnrollmentCampaign = (args) =>
    dispatchEnrollment(`${MFA_BASE}/enrollment/campaign/get`, campaignGetRef, args);

// Whether adding a user also emails them an Authenticator invite:
// { sendInvite, provider, inviteApplies }.
export const dispatchGetOnboardingSettings = (args) =>
    dispatchEnrollment(`${MFA_BASE}/onboarding/settings/get`, onboardingGetRef, { ...args, payload: {} });

// Body: { sendInvite: true|false }.
export const dispatchSetOnboardingSettings = (args) =>
    dispatchEnrollment(`${MFA_BASE}/onboarding/settings/set`, onboardingSetRef, args);

const deviceSettingsGetRef = adminRef();
const deviceSettingsSetRef = adminRef();
const adminDevicesPushRef = adminRef();

// Per-org rules for adding phones: { maxDevicesPerUser, allowAppPasswordLogin,
// newDeviceCheck: "email_otp"|"sibling"|"admin", browserSigninSkipsCheck,
// numberMatching: "off"|"high_risk"|"always" }.
export const dispatchGetDeviceSettings = (args) =>
    dispatchEnrollment(`${MFA_BASE}/devices/settings/get`, deviceSettingsGetRef, { ...args, payload: {} });

// Send only the changed fields; answers with the saved settings. A bad value is
// 400 {error} with a message meant for the admin.
export const dispatchSetDeviceSettings = (args) =>
    dispatchEnrollment(`${MFA_BASE}/devices/settings/set`, deviceSettingsSetRef, args);

// Turns one phone's sign-in requests on or off without signing it out.
// Body: { deviceId, enabled } → { success, pushEnabled }.
export const dispatchAdminDevicesPush = (args) =>
    dispatchEnrollment(`${MFA_BASE}/devices/push`, adminDevicesPushRef, args);
